package com.example.mystybag.sharedmodels.project.logic.enums

enum class PaymentProvider {
    MYPOS,      // Плащане през myPOS IPC checkout
    STRIPE;     // Плащане през Stripe Connect (Express, destination charges)

    val code: String
        get() = when (this) {
            MYPOS -> "mypos"
            STRIPE -> "stripe"
        }

    companion object {
        fun fromCode(value: String): PaymentProvider {
            return when (value.trim().lowercase()) {
                "stripe" -> STRIPE
                else -> MYPOS // Default fallback
            }
        }
    }
}
